const dataURLToBlob = (dataURL: string): Blob => {
  const [header, base64Data] = dataURL.split(",");
  const mime = header.match(/:(.*?);/)?.[1] || ""; // Lấy loại MIME
  const binaryString = atob(base64Data); // Giải mã base64
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return new Blob([bytes], { type: mime });
};

function dataURLToFile(dataURL, filename) {
  let arr = dataURL.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

export const base64ToBlob = (
  base64: string,
  contentType:
    | "application/pdf"
    | "image/jpeg"
    | "image/png"
    | "text/plain"
    | "application/json"
    | "application/octet-stream"
    | "text/html"
    | "text/css"
    | "application/javascript"
    | "application/xml"
    | "audio/mpeg"
    | "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    | "video/mp4"
): Blob => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};

export const handleFileDownload = (fileName: string, fileData: string) => {
  const fileExtension = fileName.split(".").pop()?.toLowerCase();
  const contentType =
    fileExtension === "pdf"
      ? "application/pdf"
      : "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

  const blob = base64ToBlob(fileData, contentType);
  const url = URL.createObjectURL(blob);

  if (fileExtension === "pdf") {
    // Open PDF in a new tab
    window.open(url, "_blank");
  } else {
    // download for others files like docx, xlsx, ...
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const fileToDataURL = (file: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export { dataURLToBlob, dataURLToFile, fileToDataURL };
